import { generateUtilityClasses } from '@mui/material';
import { Stack, styled } from '@mui/system';

const COMPONENT_NAME = 'PrcConversationLayout';

// Generating utility classes for inner stacks to target on sx styling if required
// No props forwards needed as it's just layout and styling can be applied this way
export const conversationLayoutClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['root', 'conversationContainer', 'inputContainer']),
};

export const Root = styled(Stack)({
  width: '100%',
  height: '100%',
  alignItems: 'center',
  overflowY: 'scroll',
  overflowX: 'hidden',
});

export const ConversationContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  flex: 1,
  paddingTop: theme.spacing(4),
  paddingInline: theme.spacing(4),
}));

export const InputContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  position: 'sticky',
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: theme.spacing(4),
  paddingInline: theme.spacing(4),

  // adding gradient background + padding for fading effect of
  // messages while scrolling
  background: `linear-gradient(0deg, ${theme.palette.background.paper}, 95%, transparent)`,
}));
